import { Component } from '@angular/core'
import { I18nDirective } from 'app/shared/directives/app-i18n.directive'

@Component({
    selector: 'form-address-unknown-warning',
    template: `<div class="col-12">
        <div class="alert alert-warning">
            <h5 class="alert-heading" i18n="@@addressDetails_postal_error_title" app-i18n="addressDetails_postal_error_title">
                Adres onbekend
            </h5>
            <p class="mb-0" i18n="@@addressDetails_postal_error_body" app-i18n="addressDetails_postal_error_body">
                Wij hebben het adres niet kunnen vinden of je hebt aangegeven de postcode niet te weten
            </p>
        </div>
    </div>`,
    standalone: true,
    imports: [I18nDirective],
})
export class FormAddressUnknownWarningComponent {}
